"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardSharePopoverButton = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var SharePopoverButton_1 = require("Project/SharePopover/SharePopoverButton");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var Configuration_1 = require("Styles/Configuration/Configuration");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ShareButton_1 = __importDefault(require("Project/SharePopover/Buttons/ShareButton"));
function DashboardSharePopoverButton(_a) {
    var projectStore = _a.projectStore, isOpen = _a.isOpen, onChange = _a.onChange;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.navBarZIndex }, function () { return (react_1.default.createElement(SharePopoverButton_1.SharePopoverButton, { button: ShareButton_1.default, projectStore: projectStore, isOpen: isOpen, onChange: onChange, usingFeature: usingFeature, recalculatePositionOnResize: true, popoverPosition: kaleidoscope_1.PopoverPosition.Left, source: TelemetryEnums_1.TelemetrySource.PageExplorer })); }));
}
exports.DashboardSharePopoverButton = DashboardSharePopoverButton;
